<template>
  <div class="notification is-info has-text-centered has-text-weight-bold ict-banner" v-if="ictUrl">
    <div class="child">
        <p>{{ $t('banners.ict-navigation') }}</p>
    </div>
    <div class="child">
            <a :href="ictUrl" target="_blank">Click here</a>
        </div>
  </div>
</template>

<script>
import { configs } from 'config';
    export default {
        name: 'InfoBanner',
        data() {
            return {
             ictUrl: configs().ICT_URL,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .hide-navbar .notification.ict-banner {
        display: none;
    }

    .notification.ict-banner {
        background-color: #101828;
        margin-bottom: 0;
        height: 0.5em;
        padding-bottom: 2em;
        padding-top: 0.5em;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }
    .notification.ict-banner .child{
        text-align: end;
    }
    .notification.ict-banner > .child > a {
        position: absolute;
        z-index: 2;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        text-decoration: none;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background-color: #f04f5f;
        border-width: 2px;
        border-style: solid;
        color: white;
        border-radius: 6px;
        border-color: #f04f5f;
        padding-left: 16px;
        padding-right: 16px;
        margin-top: -0.2em;
        margin-left: 0.5em;
    }
</style>